export const GOAL_DIAGRAMS = {
    // 两条各满 3 子的线，彼此最多共用 1 格。这里画成完全不共用的两条横线。
    twinLines: {
        boardSize: 6,
        mine: [
            [0, 0],
            [0, 1],
            [0, 2],
            [2, 0],
            [2, 1],
            [2, 2],
        ],
        others: [],
        blocks: [],
        caption: '两条三连，各自满 3 子。横竖斜都算，两条线最多只能共用 1 格。',
    },
    // 一个 2×2 角区里塞满 4 子。四个角任选一个。
    corner: {
        boardSize: 6,
        mine: [
            [0, 0],
            [0, 1],
            [1, 0],
            [1, 1],
        ],
        others: [],
        blocks: [],
        caption: '四个角上的 2×2 小方块，任选一个填满自己的 4 颗子。',
    },
    // 一条连通到底的路。八方相邻都算连通，所以可以走斜的。
    traverse: {
        boardSize: 6,
        mine: [
            [0, 2],
            [1, 2],
            [2, 3],
            [3, 3],
            [4, 2],
            [5, 2],
        ],
        others: [],
        blocks: [],
        caption: '一串连着的子，从最上一行通到最下一行（左右打通也算）。斜着也算连着。',
    },
    // 把对手一颗子的八个方向全堵死。自己的子、禁区标记、第三家的子都算墙。
    siege: {
        boardSize: 6,
        mine: [
            [1, 1],
            [1, 2],
            [1, 3],
            [2, 1],
            [2, 3],
            [3, 2],
        ],
        others: [[2, 2]],
        blocks: [
            [3, 1],
            [3, 3],
        ],
        siegeTarget: 1,
        caption: '指定那家的某颗子，八个方向全被堵住。自己的子、禁区标记都能当墙，空格不算。',
    },
    // 四个象限各至少 2 子，且任何方向都不出现 3 子连在一起。
    // 注意 (3,2)-(4,3)-(5,4) 这种斜着的三连也算犯规 —— 第一版图就栽在这里，
    // 是 tests/goal-diagrams.test.ts 把它抓出来的。
    scatter: {
        boardSize: 6,
        mine: [
            [0, 0],
            [1, 2],
            [0, 4],
            [2, 3],
            [4, 0],
            [3, 2],
            [5, 5],
            [4, 3],
        ],
        others: [],
        blocks: [],
        caption: '棋盘四等分，每一份里都有至少 2 颗子，而且全盘任何方向都不能有 3 颗连在一起。',
    },
    // 三颗子，每颗的八个邻格里都没有别人的子。
    island: {
        boardSize: 6,
        mine: [
            [0, 0],
            [0, 5],
            [5, 0],
        ],
        others: [
            [2, 2],
            [3, 3],
        ],
        blocks: [],
        caption: '三颗子，每一颗的周围八格里都不能有别人的子（自己的子和禁区标记不碍事）。',
    },
};
